<template>
  <span v-if="count" class="alert-badge" :aria-label="`${count} needing your attention`">{{ count }}</span>
</template>

<script>
export default {
  name: 'AlertBadge',
  props: {
    count: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/swoop/_variables.scss';

.alert-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 20px;
  height: 20px;
  padding: 0 $spacer-xs-4px;
  border-radius: 10px;
  background-color: var(--color-error-500);
  color: var(--color-white);
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.4px;
}
</style>
